var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.536133 29.2599H6.97797V9.91992H0.536133V29.2599Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.124 11.6871C26.769 10.2108 24.979 9.47266 22.7543 9.47266C21.9334 9.47266 21.1893 9.57382 20.5183 9.77429C19.8492 9.97662 19.2813 10.2595 18.8202 10.623C18.3591 10.9883 17.9918 11.3255 17.7163 11.6384C17.4576 11.9344 17.2046 12.2791 16.9553 12.6707V9.92042H10.5322L10.5528 10.8572C10.5641 11.4829 10.5716 13.407 10.5716 16.635C10.5716 19.8593 10.5585 24.069 10.5322 29.2604H16.9553V18.4673C16.9553 17.8059 17.0265 17.2776 17.1709 16.8879C17.4445 16.2228 17.8568 15.6683 18.4097 15.2186C18.9627 14.7709 19.6505 14.5461 20.4696 14.5461C21.5904 14.5461 22.4132 14.932 22.9398 15.7076C23.4684 16.4814 23.7308 17.5511 23.7308 18.9169V29.2604H30.1539V18.1769C30.1539 15.3254 29.4773 13.1634 28.124 11.6871Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79646 0.611328C2.71689 0.611328 1.84161 0.926074 1.17062 1.55744C0.499634 2.1888 0.166016 2.98504 0.166016 3.94801C0.166016 4.89786 0.490263 5.69222 1.14063 6.32921C1.79287 6.96619 2.65129 7.28656 3.71774 7.28656H3.7571C4.84979 7.28656 5.73257 6.96807 6.40356 6.32921C7.07267 5.69222 7.40066 4.89786 7.38942 3.94801C7.3763 2.98504 7.04268 2.1888 6.39231 1.55744C5.74194 0.926074 4.87603 0.611328 3.79646 0.611328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/LinkedIn Logo.2420823406cc12b2f1aaab0b91cd73e7.svg";
export { ForwardRef as ReactComponent };